<div mat-dialog-header class="title">
    Add Default Configuration
</div>

<div mat-dialog-content>
    <div class="flex-column">
        <mat-form-field class="full-width">
            <mat-label>Default Truck Material Density</mat-label>
            <measurement-input type="largeDensity" [unitSystem]="(quantityUnitSystem$|async)"
                [(ngModel)]="defaultDensity"></measurement-input>
        </mat-form-field>
    </div>
</div>

<div mat-dialog-actions>
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" (click)="save()">Save</button>
</div>